"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _api = require("@focaltec-suite/api");
var _core = require("@focaltec-suite/core");
var _commons = require("@focaltec-suite/commons");
var _DeblurTwoTone = _interopRequireDefault(require("@mui/icons-material/DeblurTwoTone"));
var _exportable = require("../exportable");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function UsersExportableMenu(_ref) {
  var tenantId = _ref.tenantId,
    selectedIds = _ref.selectedIds,
    selectedUsers = _ref.selectedUsers,
    total = _ref.total,
    reload = _ref.reload,
    params = _ref.params;
  var feedbackContext = (0, _react.useContext)(_commons.FeedbackContext);
  var context = (0, _react.useContext)(_core.AppContext);
  var access = context.access;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    popup = _useState2[0],
    setPopup = _useState2[1];
  var frozen = (0, _react.useMemo)(function () {
    return selectedUsers.filter(function (el) {
      return el.status === 'frozen';
    }).map(function (el) {
      return el.id;
    });
  }, [selectedUsers]);
  var onUnfreeze = (0, _react.useCallback)(function () {
    if (frozen.length === 0) {
      feedbackContext.showInfo((0, _core.translate)('users.unfreeze.empty'));
    } else {
      setPopup(true);
    }
  }, [frozen, feedbackContext]);
  var confirmUnfreeze = (0, _react.useCallback)(function () {
    setPopup(false);
    if (frozen.length === 0) return;
    feedbackContext.showBackdrop();
    (0, _api.unfreezeUsers)(tenantId, {
      ids: frozen
    }, {
      access: access
    }).then(function (result) {
      var _a, _b;
      feedbackContext.showSuccess((0, _core.translate)('users.unfreeze.success', {
        count: (_b = (_a = result === null || result === void 0 ? void 0 : result.user_ids) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0
      }));
      reload();
    })["catch"](feedbackContext.showError)["finally"](feedbackContext.closeBackdrop);
  }, [tenantId, access, frozen, reload, feedbackContext]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_exportable.ExportableComponent, {
    tenantId: tenantId !== null && tenantId !== void 0 ? tenantId : '',
    familyId: "users",
    selectedIds: selectedIds,
    total: total,
    createAction: ['PUsersCreate', 'TUsersCreate'],
    getAction: ['PUsersRead', 'TUsersRead'],
    onImported: reload,
    items: [{
      icon: /*#__PURE__*/_react["default"].createElement(_DeblurTwoTone["default"], {
        fontSize: "small",
        color: "primary"
      }),
      label: (0, _core.translate)('users.unfreeze.title'),
      onClick: onUnfreeze,
      disabled: frozen.length === 0
    }],
    getImportPromise: function getImportPromise(file, tenantId) {
      return (0, _api.importUsers)({
        name: file.name,
        path: file.path
      }, {
        tenantId: tenantId,
        access: access
      });
    },
    getTemplatePromise: function getTemplatePromise(connectorId, tenantId) {
      return (0, _api.downloadImportUsersTemplate)(connectorId, {
        tenantId: tenantId,
        access: access
      });
    },
    getExportSelectedPromise: function getExportSelectedPromise(connectorId, tenantId) {
      return (0, _api.exportSelectedUsers)(connectorId, selectedIds, {
        tenantId: tenantId,
        access: access
      });
    },
    getExportWithParamsPromise: function getExportWithParamsPromise(connectorId, tenantId, startDate, endDate) {
      return (0, _api.exportUsers)(connectorId, Object.assign(Object.assign({}, params), {
        page: 0,
        offset: 0
      }), {
        tenantId: tenantId,
        access: access
      });
    }
  }), popup && /*#__PURE__*/_react["default"].createElement(_commons.DialogPopup, {
    title: (0, _core.translate)('users.unfreeze.title'),
    onClose: function onClose() {
      return setPopup(false);
    },
    button: {
      text: (0, _core.translate)('buttons.continue'),
      onClick: confirmUnfreeze
    }
  }, (0, _core.translate)('users.unfreeze.description')));
}
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(UsersExportableMenu);